import logo from './logo.png';
import companylogo from "./AMS_Logo_Web.svg";
import apartment from "./APARTMENT.png";
import bed1 from "./1 ROOM.png";
import local from "./icon-local.svg";
import truck from "./truck.png";
import clock from "./Clock.png"
import nofee from "./no-fees.png"
import amslogo from "./black_logo-transparent_bg.png"
import superDeal from "./Super Deals.svg"
import affordably from "./AFFORDABLY.svg"
import hourIcon from "./Fast_Shipping_Clock@1x.png"
import truckIcon from "./Truck@1x.png"
import boxIcon from "./Box@1x.png"
import fuelIcon from "./Fuel@1x.png"
import iconHour from "./Moving Hours icon (1).svg"


export { logo }
export { companylogo }
export { apartment }
export { local }
export { bed1 }
export { truck }
export { clock }
export { nofee }
export { amslogo }
export { superDeal }
export { affordably }
export { hourIcon }
export { truckIcon }
export { boxIcon }
export { fuelIcon }
export { iconHour }
